import React, { useState, useEffect } from "react";
import { EnvironmentalDataContext } from "./context";

import {
  getEnvironmentalData,
  getAverageEnvironmentalData,
} from "../services/services";
import { useTranslation } from "react-i18next";

const EnvironmentalProvider = ({ children }) => {
  const [environmentalData, setEnvironmentalData] = useState(null);
  const [availableSensors, setAvailableSensors] = useState([]);
  const [averageEnvironmentalData, setAverageEnvironmentalData] =
    useState(null);
  const [loading, setLoading] = useState(true);
  const [averageLoading, setAverageLoading] = useState(true);
  const [error, setError] = useState(null);
  const [averageError, setAverageError] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    const fetchEnvironmental = async () => {
      const environmental = await getEnvironmentalData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            const tempResponse = response.map((item) => {
              return {
                ...item,
                details: item.details.filter(
                  (sensor) => !sensor.sensorvar_description.includes("LA"),
                ),
              };
            });

            return tempResponse;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      const tempSensors = [];
      environmental.forEach((item) => {
        item.details.forEach((detail) => {
          let name;
          if (detail.sensorvar_icon !== "29.svg") {
            name = `dataNames.${detail.sensorvar_icon.slice(0, -4)}`;
          }
          if (!tempSensors.includes(name)) {
            tempSensors.push(name);
          }
        });
      });

      setAvailableSensors(tempSensors.filter((item) => item !== undefined));

      setEnvironmentalData(environmental);
    };

    const fetchAverageEnvironmental = async () => {
      const averageEnvironmental = await getAverageEnvironmentalData({
        lang: "el",
      })
        .then((response) => {
          if (response.length > 0) {
            setAverageLoading(false);
            return response;
          } else {
            setAverageLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setAverageLoading(false);
          setAverageError(error);
        });

      setAverageEnvironmentalData(averageEnvironmental);
    };

    fetchEnvironmental();
    fetchAverageEnvironmental();
  }, []);

  return (
    <EnvironmentalDataContext.Provider
      value={{
        environmentalData,
        setEnvironmentalData,
        averageEnvironmentalData,
        setAverageEnvironmentalData,
        environmentalLoading: loading,
        availableSensors,
        error,
        averageLoading,
        averageError,
      }}
    >
      {children}
    </EnvironmentalDataContext.Provider>
  );
};

export default EnvironmentalProvider;
